export default "__VITE_ASSET__930878a6__"